import { ChildrenStoreData } from "src/shared/types/src";
import { getAxiosInstance } from "../api";
import { profileData } from "../mock";
import { API_PART_URL } from "src/shared/config/src";
// import { ChildrenStoreData } from "@parent-app/types";
// import { API_PART_URL } from "@parent-app/config";

export const getProfileDetails = async ({ child }: { child: ChildrenStoreData }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();

    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;

    return retryAxios.get(`${child.instanceUrl}${API_PART_URL}/child/${child.childId}/basic-details`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}